import React, { useState } from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import WhenCondition from '../misc/WhenCondition'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import InputWeek from './InputWeek'
import SVGIcon from '../helpers/icons'

function InputWeeks (props) {
  const moment = extendMoment(Moment)

  const manager = usePortManager()
  const settings_manager = useSettingsManager()

  const _settings = props.name !== props.parent ? settings_manager.getInputOptionSettings(props.parent, props.name) : settings_manager.getInputOptionSettings(props.name, props.value)
  const input_settings = typeof _settings === 'object' ? _settings : { title: props.value }

  const title = typeof input_settings.title === 'string' ? <strong>{input_settings.title}</strong> : null
  const description = typeof input_settings.description === 'string' ? <p>{input_settings.description}</p> : null

  const [current_month, setCurrentMonth] = useState(
    0
  )

  const ignored_weeks = settings_manager.getOtherSettings('ignored_weeks', '52,53,1').split(',').map((str) => parseInt(str.trim()))
  const week_offset = parseInt(settings_manager.getOtherSettings('week_offset', 3))
  const number_of_weeks = parseInt(settings_manager.getOtherSettings('number_of_weeks', 8))

  const items = []
  const months = []

  for (let i = week_offset; i <= week_offset + number_of_weeks; i++) {
    let week = moment().add(i, 'weeks')
    let weeknumber = week.week()

    if (ignored_weeks.indexOf(weeknumber) >= 0) continue

    let month = week.format('MM')
    if (months.indexOf(month) < 0) months.push(month)

    items.push(
      <WhenCondition key={weeknumber} condition={'equals'} arg={[current_month, months.indexOf(month)]}>
        <InputWeek name={props.name} value={weeknumber}/>
      </WhenCondition>
    )
  }
  const next_month = function () {
    if (current_month < (months.length - 1)) setCurrentMonth(current_month + 1)
  }
  const prev_month = function () {
    if (current_month > 0) setCurrentMonth(current_month - 1)
  }

  moment.locale(window.main_theme_objects.lang ?? 'en')

  const month_diff = moment().add(week_offset, 'week').format('M') - moment().format('M')

  const month_label = () => <h3
    className={'month-label'}>{moment().add(current_month + month_diff, 'month').startOf('month').format('MMMM YYYY')}</h3>

  const nextActive = current_month >= 0 && current_month <= (months.length - 1) - 1
  const prevActive = current_month >= 1 && current_month <= (months.length - 1)
  const nextClass = nextActive ? 'nav-arrow nav-arrow--next' : 'nav-arrow nav-arrow--next nav-arrow--disabled'
  const prevClass = prevActive ? 'nav-arrow nav-arrow--prev' : 'nav-arrow nav-arrow--prev nav-arrow--disabled'

  return (
    <aside className={'input input-weeks'} data-size={props.size}>
      <label>
        {title}
        {description}
      </label>

      <div className={'input-weeks__title'}>
        {month_label()}
        <div className={'nav-arrows'}>
          <button className={prevClass} onClick={() => prev_month()} aria-label={'Forrige uge'}><SVGIcon
            type={'arrow-right'} className={'nav-arrow__icon'} fill={'#000'}/></button>
          <button className={nextClass} onClick={() => next_month()} aria-label={'Næste uge'}><SVGIcon
            type={'arrow-right'} className={'nav-arrow__icon'} fill={'#000'}/></button>
        </div>
      </div>

      <div className={'input-grid'}>
        {items}
      </div>
    </aside>
  )
}

export default observer(InputWeeks)